
const testimonials = [
	{
		id: 2,
		name: 'Jessica',
		role: 'Student, 2025',
		quote: 'Top national IEB matric achiever.',
		video: '/media/img/testimonial.mp4', // or a YouTube embed URL
		// no avatar – video will be shown instead
	},
		//{
		//id: 3,
		//name: '',
		//role: '',
		//quote: '',
		//avatar: '',
		// no video
	//},
	// add more
];

const Testimonials = () => {
	return (
		<section className="py-12 bg-gray-50 rounded-lg m-2">
			<div className="container mx-auto px-4">
				<h2 className="text-4xl font-bold text-center mb-8">What Our Clients Say</h2>
				<div className="grid grid-cols-1 md:grid-cols-2 px-2 lg:grid-cols-3 gap-6">
					{testimonials.map((t) => (
						<div key={t.id} className="bg-white p-6 rounded-lg shadow">
							{/* If there's a video, show it above the quote */}
							{t.video && (
								<div className="mb-4">
									<video
										src={t.video}
										controls
										className="w-full rounded-lg"
									/>
								</div>
							)}

							<p className="italic mb-4">"{t.quote}"</p>

							<div className="flex items-center">
								{/* Show avatar only if there's no video */}
								{!t.video && t.avatar && (
									<img
										src={t.avatar}
										alt={t.name}
										className="w-10 h-10 rounded-full mr-3"
									/>
								)}
								<div>
									<p className="font-semibold">{t.name}</p>
									<p className="text-sm text-gray-600">{t.role}</p>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Testimonials;